(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/objectSpread", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/assertThisInitialized", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/defineProperty", "react", "prop-types", "../../context"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/objectSpread"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/assertThisInitialized"), require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("prop-types"), require("../../context"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectWithoutProperties, global.objectSpread, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.getPrototypeOf, global.assertThisInitialized, global.inherits, global.defineProperty, global.react, global.propTypes, global.context);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectWithoutProperties2, _objectSpread2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _getPrototypeOf2, _assertThisInitialized2, _inherits2, _defineProperty2, _react, _propTypes, _context) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var InnerGrid =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(InnerGrid, _React$Component);

    function InnerGrid(props, context) {
      var _this;

      (0, _classCallCheck2.default)(this, InnerGrid);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InnerGrid).call(this, props, context));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
        var core = _this.grid.core;

        if (core && core.emitter) {
          core.emitter.on('refresh', function () {
            _this.forceUpdate();
          });
          core.emitter.on('grid_props_update', function () {
            _this.forceUpdate();
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderTable", function (grid) {
        var core = grid.core;

        if (!_this.grid && grid) {
          _this.grid = grid;
        }

        var children = _this.props.children;
        var otherProps = (0, _objectSpread2.default)({}, _this.props);

        if (!core.multiple) {
          delete otherProps.dataSource;
          otherProps.dataSource = core.getDataSource();
        }

        delete otherProps.children;
        otherProps.loading = core.isLoading;
        var element = null;

        if (_react.default.isValidElement(children)) {
          element = _react.default.cloneElement(children, otherProps);
          return _react.default.createElement("div", {
            className: "table-wrapper"
          }, element);
        }

        return null;
      });
      var _this$props$dataSourc = _this.props.dataSource,
          dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc;
      return _this;
    }

    (0, _createClass2.default)(InnerGrid, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(_context.Consumer, null, this.renderTable);
      }
    }]);
    return InnerGrid;
  }(_react.default.Component);

  (0, _defineProperty2.default)(InnerGrid, "propTypes", {
    children: _propTypes.default.element
  });
  (0, _defineProperty2.default)(InnerGrid, "defaultProps", {});

  function Gridify(Com) {
    return function Grid(props) {
      var children = props.children,
          others = (0, _objectWithoutProperties2.default)(props, ["children"]);
      return _react.default.createElement(InnerGrid, others, _react.default.createElement(Com, null, children));
    };
  }

  var _default = Gridify;
  _exports.default = _default;
});